import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const requiredAddressValidator: (name: string) => ValidatorFn =
  (name) =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!(<FormGroup>control.parent)?.controls[name]?.value?.[name]) {
      return { 'required-address': true };
    }
    return null;
  };
